module.exports = __webpack_public_path__ + "img/clipboard_text_black.25e05c38.svg";